import { Skeleton } from 'antd';
import React, { useState, useEffect } from 'react';
import { Table, Loader, Segment, Dimmer, Image } from "semantic-ui-react";
import P450Table from './Tables';

function KnowP450s() {
	const [error, setError] = useState(null);
	const [isLoaded, setIsLoaded] = useState(false);
	const [items, setItems] = useState([]);
	const [url, setUrl] = useState(null);
	const [image, setImage] = useState(null);
	const [imagename, setImagename] = useState(null);
	const [show, setShow] = useState(false);

	const handleClose = () => setShow(false);
	function handleShow() {
		setShow(true);
	};

	useEffect(() => {
		setUrl('./resource.json');
	})

	useEffect(() => {
		async function getData() {
			fetch(url)
				.then(res => res.json())
				.then(
					(result) => {
						setIsLoaded(true);
						setItems(result);
						console.log(result);
					},

					(error) => {
						setIsLoaded(true);
						setError(error);
						console.log(error);
					}
				);
		}

		if (url != null) {
			getData();
		}


	}, [url])

	function handleGraph(e) {
		let current_graph = e.target.value;
		console.log(current_graph);
	}

	if (error) {
		return (
			<div>
				Error: {error.message}
			</div>
		);
	} else if (!isLoaded) {
		return (
			<div>
				<Segment>
					<Dimmer active inverted>
						<Loader size='massive'>Loading</Loader>
					</Dimmer>

					<Image src='./paragraph.png' />
				</Segment>
			</div>
		);
	} else {
		//console.log(items);
		return (
			<div>



				{
					isLoaded
					?
					<P450Table data={items} loading={!isLoaded}/>
					:
					<Skeleton active loading />
				}

			</div>
		);
	}
}

export default KnowP450s;